import Axios from "../../Config/API";
import Service from "../../Service";

export async function EfetuarDiscagemServices(
    telefoneContato: string,
    idCaso: number
) {
    return Service(
        Axios.post(
            `/home/telefoniacapys/efetuardiscagem?telefoneContato=${telefoneContato}&idCaso=${idCaso}`
        )
    );
}

export async function LogoutAgenteServices() {
    return Service(Axios.post(`/home/telefoniacapys/logoutagente`));
}

export async function LoginAgenteServices() {
    return Service(Axios.post(`/home/telefoniacapys/loginagente`));
}

export async function DesligarChamadaServices(idCaso: number) {
    return Service(
        Axios.post(`/home/telefoniacapys/desligarchamada?idCaso=${idCaso}`)
    );
}
